import React from 'react'
import { Alert, Button, Stack } from '@mui/material'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { hasOperationUpdate, isUsingOlderVersion, resolveOperationUpdate } from './operationApprovedUpdate'

/**
 * OperationUpdateBanner (C5, §8.7) — el aviso de que la operación de este nodo tiene una versión más
 * nueva (CA5.1, S85), con sus dos acciones: "Update" (K49) y "Dismiss" (K43).
 *
 * Tras descartar, el aviso deja de interrumpir y en su lugar queda el hecho: "Using an older
 * version" (K42, S105). El descarte es del VÍNCULO y compartido entre usuarios (S107): no es una
 * preferencia local, y por eso lo decide `NodeOperationLink` y no este componente.
 */
const OperationUpdateBanner = ({ operationLink = {}, onUpdate = () => {}, onDismiss = () => {} }) => {
  const { t_ } = useSmartTranslation()
  const update = resolveOperationUpdate(operationLink)

  if (hasOperationUpdate(operationLink)) {
    return (
      <Alert
        severity='info'
        data-testid='operation-update-banner'
        action={
          <Stack direction='row' spacing={1}>
            <Button variant='outlined' size='small' data-testid='operation-update-action' onClick={() => onUpdate(update)}>
              {t_('Update')}
            </Button>
            <Button variant='outlined' size='small' data-testid='operation-dismiss-action' onClick={() => onDismiss(update.versionNumber)}>
              {t_('Dismiss')}
            </Button>
          </Stack>
        }
      >
        {t_('New operation version available')}
      </Alert>
    )
  }

  if (isUsingOlderVersion(operationLink)) {
    return (
      <Alert severity='warning' data-testid='operation-using-older-version'>
        {t_('Using an older version')}
      </Alert>
    )
  }

  return null
}

export default OperationUpdateBanner
